import { languageMap } from ".."

languageMap.fortran = {
	comments: {
		line: "!",
	},
}
